module.exports = __webpack_public_path__ + "static/media/Cute.53df9933.webp";